import React, { FC, ReactNode, useCallback } from 'react';

import PropTypes from 'prop-types';

import {
  ViewDensityNarrowIcon,
  ViewDensityStandardIcon,
  ViewDensityWideIcon,
} from '@adsk/alloy-react-icon';
import { useTheme } from '@adsk/alloy-react-styles';
import { stylePropType, StylableComponent } from '@adsk/alloy-react-theme';

import DensityOption from './DensityOption';
import { TABLE_SIZES } from '../../consts';
import useTableSize from '../../hooks/useTableSize';
import { useTranslation } from '../../i18n';
import { Themeable, TableSize } from '../../types';

type TableConfigurationDensityProps = StylableComponent<HTMLDivElement> &
  Themeable & {
    label?: ReactNode;
    setSize: (size: TableSize) => void;
  };

const TableConfigurationDensity: FC<TableConfigurationDensityProps> = ({
  label,
  tableSize,
  setSize,
  className,
  style,
}) => {
  const tableSizeTheme = useTableSize(tableSize);
  const theme = useTheme();
  const configuration = theme.tokens?.component?.table?.configuration;

  const { t } = useTranslation();
  const densityLabel = t('DENSITY');

  return (
    <div
      className={className}
      css={[
        {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        },
        style,
      ]}
    >
      <div css={configuration?.menuHeading}>{label || densityLabel}</div>
      <div
        css={[
          {
            display: 'flex',
            padding: `0 16px`,
          },
        ]}
      >
        <DensityOption
          setSize={setSize}
          size={TABLE_SIZES.SMALL}
          renderIcon={useCallback(
            (p) => (
              <ViewDensityNarrowIcon {...p} />
            ),
            [],
          )}
          currentSize={tableSizeTheme.size}
        />
        <DensityOption
          setSize={setSize}
          size={TABLE_SIZES.MEDIUM}
          renderIcon={useCallback(
            (p) => (
              <ViewDensityStandardIcon {...p} />
            ),
            [],
          )}
          currentSize={tableSizeTheme.size}
        />
        <DensityOption
          setSize={setSize}
          size={TABLE_SIZES.LARGE}
          renderIcon={useCallback(
            (p) => (
              <ViewDensityWideIcon {...p} />
            ),
            [],
          )}
          currentSize={tableSizeTheme.size}
        />
      </div>
    </div>
  );
};

TableConfigurationDensity.propTypes = {
  label: PropTypes.any,
  setSize: PropTypes.func.isRequired,
  style: stylePropType,
  className: PropTypes.string,
};

export default TableConfigurationDensity;
